import { render, staticRenderFns } from "./HelpMiniature.vue?vue&type=template&id=17d72073&scoped=true&"
import script from "./HelpMiniature.vue?vue&type=script&lang=js&"
export * from "./HelpMiniature.vue?vue&type=script&lang=js&"
import style0 from "./HelpMiniature.vue?vue&type=style&index=0&id=17d72073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d72073",
  null
  
)

export default component.exports